module.exports = __webpack_public_path__ + "img/23-1.0f9c0c83.png";